import React from "react";
import "./ReportCustomization.css";

const ReportCustomization = () => {
    return (
        <div className="report-customization" style={{ position: "relative", opacity: 0.4, pointerEvents: "none" }}>
            <div className="report-customization__title-container">
                <h1>Report Customization</h1>
                <h2 className="report-customization__report-preview">Report Preview</h2>
                <button className="report-customization__download-button">
                    Download <span className="report-customization__triangle-custom">▼</span>
                </button>
            </div>

            <div className="report-customization__main-container">
                <div className="report-customization__sections">
                    <div className="report-customization__section">
                        <h3>Select Metrics to Display</h3>
                        <div className="report-customization__manage-btn-container">
                            <button className="report-customization__manage-btn">
                                Revenue <span className="triangle-custom">&#9660;</span>
                            </button>
                        </div>
                        <div className="report-customization__manage-btn-container">
                            <button className="report-customization__manage-btn">
                                Engagement Score <span className="triangle-custom">&#9660;</span>
                            </button>
                        </div>
                        <div className="report-customization__manage-btn-container">
                            <button className="report-customization__manage-btn">
                                Retention <span className="triangle-custom">&#9660;</span>
                            </button>
                        </div>
                    </div>
                    <div className="report-customization__section">
                        <h3>Date Range Selection</h3>
                        <div className="report-customization__manage-btn-container">
                            <button className="report-customization__manage-btn">
                                From <span className="triangle-custom">&#9660;</span>
                            </button>
                        </div>
                        <div className="report-customization__manage-btn-container">
                            <button className="report-customization__manage-btn">
                                To <span className="triangle-custom">&#9660;</span>
                            </button>
                        </div>
                    </div>
                    <div className="report-customization__section">
                        <h3>Filter Options</h3>
                        <div className="report-customization__manage-btn-container">
                            <button className="report-customization__manage-btn">
                                Client segments <span className="triangle-custom">&#9660;</span>
                            </button>
                        </div>
                        <div className="report-customization__manage-btn-container">
                            <button className="report-customization__manage-btn">
                                Geographic regions <span className="triangle-custom">&#9660;</span>
                            </button>
                        </div>
                        <div className="report-customization__manage-btn-container">
                            <button className="report-customization__manage-btn">
                                Services plans <span className="triangle-custom">&#9660;</span>
                            </button>
                        </div>
                        <div className="report-customization__manage-btn-container">
                            <button className="report-customization__manage-btn">
                                Assigned managers <span className="triangle-custom">&#9660;</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="report-customization__image-container">
                    <img src="report.png" alt="Report Customization" className="report-customization__image" />
                </div>
            </div>

            <div 
                style={{ 
                    position: "absolute", 
                    top: "50%", 
                    left: "50%", 
                    transform: "translate(-50%, -50%)", 
                    fontSize: "40px", 
                    fontWeight: "bold", 
                    color: "rgb(0, 0, 0)", 
                    textAlign: "center", 
                    zIndex: 10
                }}
            >
                Coming Soon
            </div>
        </div>
    );
};

export default ReportCustomization;
